// This file was auto-generated by Fern from our API Definition.
export const ErrorSeverity = {
    Critical: "CRITICAL",
    Warning: "WARNING",
};
